import { identity, sortBy } from 'lodash/fp';
import { getHash } from '../../utils/getHash';
import { sortOccupancyData } from '../../utils/sortOccupancyData';
import { OccupancyData } from '../resourceOrder/occupancyTypes';

export interface GetPricingHashOptions {
    startDate: string | undefined;
    endDate: string | undefined;
    enterpriseId: string;
    categoryId: string | undefined;
    voucherCode: string | undefined;
    productIds: string[];
    occupancyData: OccupancyData[];
}

export const getPricingHash = ({
    startDate,
    endDate,
    enterpriseId,
    categoryId,
    voucherCode,
    productIds,
    occupancyData,
}: GetPricingHashOptions) =>
    getHash({
        startDate,
        endDate,
        enterpriseId,
        categoryId,
        voucherCode,
        productIds: sortBy(identity)(productIds),
        occupancyData: sortOccupancyData(occupancyData),
    });
